import { IconSquareCheck } from '@tabler/icons-react'

import {
  CheckboxCaptureBlock,
  SelectAllCaptureBlock as SelectAllCaptureBlockType,
  TemplateData,
} from '../../types/blueprint'

import { Button } from '@/components/shared-components/BUI/Button'
import { useTemplateRenderer } from '@/context/templateRendererContext'
import { useBreakpoint } from '@/hooks/useBreakpoint'

const findBlockGroup = (template: TemplateData, blockId: string) => {
  for (let i = 0; i < template?.sections?.length; i++) {
    const section = template.sections[i]

    for (let j = 0; j < section.blockGroups?.length; j++) {
      const blockGroup = section.blockGroups[j]

      for (let k = 0; k < blockGroup.blocks?.length; k++) {
        if (blockGroup.blocks[k].id === blockId) {
          return blockGroup
        }
      }
    }
  }
  return null
}

type Props = {
  block: SelectAllCaptureBlockType
}

export const SelectAllCaptureBlock: React.FC<Props> = ({ block }) => {
  const isMobile = useBreakpoint('md')

  const { templateResponseData, form } = useTemplateRenderer()

  const onClick = () => {
    const blockGroup = findBlockGroup(templateResponseData, block.id)

    if (!blockGroup) return null

    const checkboxFields = blockGroup.blocks.filter(
      (b) => b.kind === 'capture' && b.type === 'checkbox'
    ) as CheckboxCaptureBlock[]

    const selectedFields = checkboxFields.reduce((agg, curr) => {
      return {
        ...agg,
        [curr.id]: curr.checkboxes.map((c) => c.value),
      }
    }, {})

    form.setFieldsValue(selectedFields)
  }

  return (
    <Button
      onClick={onClick}
      icon={<IconSquareCheck size={16} />}
      style={{ width: isMobile ? '100%' : 'auto' }}
    >
      Select all
    </Button>
  )
}
